// Projects sourced from: https://github.com/Ja-yy?tab=repositories :contentReference[oaicite:0]{index=0}

const List = [
  {
    title: "hugo noir blog",
    description:
      "Forked from prxshetty/hugo-noir. Hugo Noir is a clean, minimalistic theme for Hugo with a focus on readability and simplicity.",
    projectLinkGithub: "https://github.com/Ja-yy/hugo-noir-blog",
    siteLink: "",
    skill: "HTML (Hugo)",
    projectImage: "hugo-noir-blog",
    year: 2026,
  },
  {
    title: "Django Advance ORM",
    description:
      "An e-commerce REST API showcasing Django's advanced ORM capabilities including query optimization, complex aggregations, subqueries, and business analytics.",
    projectLinkGithub: "https://github.com/Ja-yy/Django-Advance-ORM",
    siteLink: "",
    skill: "Python (Django)",
    projectImage: "Django-Advance-ORM",
    year: 2025,
  },
  {
    title: "Project Idea Finder",
    description:
      "An AI-powered project submission platform with intelligent duplicate detection and smart feature suggestions.",
    projectLinkGithub: "https://github.com/Ja-yy/Project-Idea-Finder",
    siteLink: "",
    skill: "TypeScript + Python",
    projectImage: "Project-Idea-Finder",
    year: 2025,
  },
  {
    title: "QnA With RAG",
    description: "RAG application to chat with text files.",
    projectLinkGithub: "https://github.com/Ja-yy/QnA-With-RAG",
    siteLink: "",
    skill: "Python (RAG, Chroma, Docker, Streamlit)",
    projectImage: "QnA-With-RAG",
    year: 2024,
  },
  {
    title: "web image scraper",
    description: "Scrape important images from a given webpage.",
    projectLinkGithub: "https://github.com/Ja-yy/web-image-scraper",
    siteLink: "",
    skill: "Python",
    projectImage: "web-image-scraper",
    year: 2024,
  },
  {
    title: "LinkedIn jobs parser",
    description:
      "A tool to scrape and extract detailed job listings from LinkedIn.",
    projectLinkGithub: "https://github.com/Ja-yy/LinkedIn-jobs-parser",
    siteLink: "",
    skill: "Python (FastAPI, Selenium)",
    projectImage: "LinkedIn-jobs-parser",
    year: 2024,
  },
  {
    title: "iNotebook backend",
    description:
      "Backend code for the iNotebook project, Clone of Google Keep Notes App.",
    projectLinkGithub: "https://github.com/Ja-yy/Inotebook_backend",
    siteLink: "",
    skill: "Python (Fastapi)",
    projectImage: "Inotebook_backend",
    year: 2024,
  },
  {
    title: "Invoice Extractor",
    description:
      "Streamlit app leveraging OpenAI's LLM for invoice extraction, supporting PDF files and offering JSON/CSV outputs.",
    projectLinkGithub: "https://github.com/Ja-yy/Invoice-extractor",
    siteLink: "",
    skill: "Python (Streamlit, LLM)",
    projectImage: "Invoice-extractor",
    year: 2024,
  },
  {
    title: "Twitter Scraper",
    description:
      "Scraper  user IDs, names, and profile links based on specified keywords from Twitter.",
    projectLinkGithub: "https://github.com/Ja-yy/Twitter-scraper-streamlit",
    siteLink: "",
    skill: "Python (Streamlit)",
    projectImage: "Twitter-scraper-streamlit",
    year: 2024,
  },
  {
    title: "Chicken Disease Classification",
    description:
      "Classify chicken fecal samples into healthy and disease categories.",
    projectLinkGithub:
      "https://github.com/Ja-yy/Chicken-Disease-Classification",
    siteLink: "",
    skill: "Python (ML, TensorFlow, DVC)",
    projectImage: "Chicken-Disease-Classification",
    year: 2023,
  },
  {
    title: "SQLAlchemy ORM Flask",
    description:
      "This repository accompanies the SQLAlchemy ORM structure for Flask.",
    projectLinkGithub: "https://github.com/Ja-yy/SQLAlchemy-ORM-Flask",
    siteLink: "",
    skill: "Python (Flask, SQLAlchemy)",
    projectImage: "SQLAlchemy-ORM-Flask",
    year: 2022,
  },
];

export default List;
